// Google Analytics 4 (gtag.js) com CONSENT MODE v2 (modo avancado).
// Chave de consentimento partilhada com components/CookieConsent.jsx e
// lib/metaPixel.js ('pigmentos-cookie-consent' = 'accepted' | 'rejected').

const GA_ID = 'G-J20SXWE5XP';
const ADS_ID = 'AW-18321042589'; // Google Ads (21/09/2026): etiqueta de conversao, a par do GA4.
const CONSENT_KEY = 'pigmentos-cookie-consent';

let loaded = false;

// ---------------------------------------------------------------------------
// 15/09/2026: passou de BLOQUEIO DURO para CONSENT MODE v2 AVANCADO.
//
// Como estava: o gtag so' era carregado depois de a pessoa aceitar. Quem
// recusava ou ignorava o banner era invisivel, e o Google nao tinha como
// estimar o que se perdeu. Num site com pouco volume, isso e' a diferenca
// entre ter dados e nao ter.
//
// Como esta': o gtag carrega SEMPRE, mas com os quatro sinais NEGADOS por
// omissao. Sem consentimento nao se escreve cookie nenhum nem se manda
// identificador nenhum; o que sai e' um ping sem cookies, que e' o que permite
// ao Google modelar as conversoes de quem recusou.
//
// ⚠️ ISTO E' UMA MUDANCA REAL DE COMPORTAMENTO, e a Licinia decidiu-a a
// 15/09/2026 sabendo disto: antes, quem carregava em "rejeitar" nao enviava
// absolutamente nada; agora envia um sinal sem identificadores. E' o mecanismo
// desenhado pelo Google para o efeito (modo avancado), mas nao e' silencio
// absoluto.
//
// 🔙 PARA VOLTAR ATRAS (modo basico, silencio total a quem recusa): trocar a
// chamada a `setupGoogleAnalyticsConsent()` de volta pelo padrao antigo, ou
// seja so' chamar `loadGA()` dentro do `if (... === 'accepted')` e nao antes.
// A modelacao deixa de funcionar, e e' esse o preco.
// ---------------------------------------------------------------------------

function gtag() {
  window.dataLayer.push(arguments);
}

function loadGA() {
  if (loaded || typeof window === 'undefined') return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  // 🔴 A ORDEM IMPORTA: o `consent default` tem de ser empurrado para o
  // dataLayer ANTES do script do gtag e antes do `config`. Ao contrario,
  // ha' uma janela em que o GA corre sem restricao nenhuma.
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',        // exigido pelo Consent Mode v2
    ad_personalization: 'denied',  // exigido pelo Consent Mode v2
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted',   // o unico que nao depende de consentimento
    wait_for_update: 500           // ms de espera por uma decisao, para nao
                                   // perder os eventos dos primeiros instantes
  });

  // Sem `ad_storage`, tira os identificadores dos pedidos de anuncios.
  gtag('set', 'ads_data_redaction', true);
  // Passa o gclid no URL em vez de cookie, para nao partir a atribuicao do
  // Google Ads em quem nao aceitou.
  gtag('set', 'url_passthrough', true);

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  gtag('js', new Date());
  gtag('config', GA_ID);
  gtag('config', ADS_ID);
}

function aplicarConsentimento(valor) {
  if (typeof window === 'undefined' || !window.gtag) return;
  const concedido = valor === 'accepted' ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    ad_storage: concedido,
    analytics_storage: concedido,
    ad_user_data: concedido,
    ad_personalization: concedido,
    functionality_storage: concedido,
    personalization_storage: concedido
  });
}

// Dispara um evento GA4 (ex.: 'generate_lead', 'contact').
// Com Consent Mode, isto pode e deve correr mesmo sem consentimento: o gtag
// trata de mandar sem cookies quando os sinais estao negados.
export function trackGAEvent(name, params) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, params || {});
  }
}

export function setupGoogleAnalyticsConsent() {
  if (typeof window === 'undefined') return;

  loadGA(); // sempre, mas com tudo negado ate' haver decisao

  try {
    const guardado = localStorage.getItem(CONSENT_KEY);
    if (guardado === 'accepted' || guardado === 'rejected') {
      aplicarConsentimento(guardado);
    }
  } catch {
    /* localStorage indisponivel: fica tudo negado, que e' o lado seguro */
  }

  window.addEventListener('cookie-consent-change', (e) => {
    aplicarConsentimento(e.detail);
  });
}
